import type { ITableServicePort } from '@onboarding/application/ports';

/**
 * Use case for fetching existing service area names from the backend.
 * Used to validate area names before creation, preventing duplicates.
 *
 * @param props.tableServicePort - ITableServicePort implementation (injected)
 * @returns Use case executor
 */
export const fetchExistingAreaNamesUseCase = (props: { tableServicePort: ITableServicePort }) => {
  const { tableServicePort } = props;

  const execute = async (): Promise<string[]> => {
    return tableServicePort.getExistingAreaNames();
  };

  return { execute };
};
